var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8548 7.69403L5.19446 4.03368C5.08684 3.92606 4.91272 3.92606 4.80554 4.03368L1.1452 7.69403C0.938272 7.90095 0.60273 7.90095 0.395367 7.69403L0.155194 7.45385C-0.0517313 7.24693 -0.0517313 6.91139 0.155194 6.70402L4.61743 2.24179C4.82873 2.03049 5.17127 2.03049 5.38257 2.24179L9.84481 6.70402C10.0517 6.91095 10.0517 7.24649 9.84481 7.45385L9.60463 7.69403C9.39771 7.90095 9.06217 7.90095 8.8548 7.69403Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/ArrowUpIcon.a5331fae28ea0e87084cdfdbbf49cff9.svg";
export { ForwardRef as ReactComponent };